module.exports = __webpack_public_path__ + "img/csgo_h.d588f1a7.svg";